import './utils/lite-youtube-embed'

import './style/styles-problematics.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/problematics'

Object.values(features).forEach(createComponent)
